/**
 * The host application that opened a session through an external launch, carried in the
 * `launch_source` claim of the access token.
 *
 * These values must match the backend constants exactly:
 * - Backend: Leo.Cars.Raptor.Core/Authentication/LaunchSources.cs
 *
 * A new host adds its value here and on the backend in step.
 */
export enum LaunchSource {
    /** Opened from the Marlin Blue Workshop Dashboard. Mirrors LaunchSources.BlueDashboard. */
    BlueDashboard = 'blue_dashboard',
}
